// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'f6b3b631-a7c5-44af-b1a4-1c4dbc41b3b1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Icon_Button',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '30949225-a806-47bc-8bf0-29bbaa7e0d08',
      type: 'Sprite',
      name: '',
      className: '',
      x: -2,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Daily_Reward_Icon_Coins',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b787170f-d971-458a-9c8a-21f21fbca328',
      type: 'Container',
      name: 'notificationDot',
      className: '',
      x: 59,
      y: -31,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd288ad50-856b-4b6d-b3f9-201be30b9b5e',
      type: 'Sprite',
      name: 'labelContainer',
      className: '',
      x: 0,
      y: 47,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Main_Menu_Icon_Counter_Full',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f997c57d-34ab-4994-82f4-533a20933dd6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Notification_Dot',
      parent: 'b787170f-d971-458a-9c8a-21f21fbca328'
    },
    {
      id: 'b5aa0f11-63b8-4250-a1ec-ad123181b48a',
      type: 'Text',
      name: 'notificationAmount',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b787170f-d971-458a-9c8a-21f21fbca328'
    },
    {
      id: '4f45f37a-b2b2-4dd8-bbd2-d3dbc913950f',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'FREE',
      localize: true,
      maxWidth: 80,
      maxHeight: 30,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#aa1501',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd288ad50-856b-4b6d-b3f9-201be30b9b5e'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: 'd4cdab2f-4c5f-4427-9fad-56415187f5ef',
      name: 'boop',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: 'a5647495-ee09-4128-a454-ec6640b4c1bb',
          type: 'Tween',
          name: 'scaleBig',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 0,
          sourceName: 'labelContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '7ff7e1d3-41cb-456d-9d64-29048d132a4b',
          type: 'Tween',
          name: 'scaleBack',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 150,
          sourceName: 'labelContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '6f09c6f9-0712-4a26-a6a3-d83cdaef4005',
          type: 'Tween',
          name: 'scaleBig2',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 300,
          sourceName: 'labelContainer',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '801101b3-b1d7-478b-8401-acce48cd952c',
          type: 'Tween',
          name: 'scaleBack2',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 450,
          sourceName: 'labelContainer',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class DailyRewardIconLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  notificationDot!: Container;
  labelContainer!: Sprite;
  notificationAmount!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class boop {
  Layout: {
    labelContainer: object;
  };

  BlockTypeByName: {
    scaleBig: object;
    scaleBack: object;
    scaleBig2: object;
    scaleBack2: object;
  };

  flowData = raw.animations[0];
}
